var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScaleBackend = function SvgScaleBackend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 111,
    fill: "none",
    viewBox: "0 0 110 111"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#scale-backend_svg__clip0_12030_11727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.481,
    cy: 91.999,
    r: 18.403,
    fill: "url(#scale-backend_svg__paint0_linear_12030_11727)",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M84.483 110.403c2.763 0 5.13-2.227 6.777-5.52 1.661-3.323 2.674-7.879 2.674-12.883 0-5.005-1.013-9.56-2.674-12.884-1.647-3.293-4.014-5.52-6.777-5.52s-5.13 2.227-6.777 5.52C76.044 82.44 75.03 86.995 75.03 92c0 5.005 1.013 9.561 2.675 12.884 1.646 3.293 4.013 5.52 6.777 5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.554 84.838c-5.214-.012-10.39-.63-15.324-1.83-.318-.075-.58-.238-.73-.45a.67.67 0 0 1-.069-.686c.11-.227.342-.413.645-.52.302-.106.651-.124.971-.048 9.36 2.3 19.535 2.3 28.896 0 .315-.072.658-.053.954.053s.521.29.628.514a.67.67 0 0 1-.056.68c-.143.212-.397.377-.708.457-4.893 1.204-10.031 1.822-15.207 1.83M69.614 102.713a1.66 1.66 0 0 1-.743-.175 1 1 0 0 1-.462-.452.69.69 0 0 1 .124-.677c.163-.205.433-.357.75-.422 9.875-2.435 20.604-2.435 30.479 0 .311.081.565.246.707.46a.67.67 0 0 1 .056.682c-.107.224-.332.409-.627.516a1.73 1.73 0 0 1-.952.054c-9.348-2.297-19.498-2.297-28.846 0a1.4 1.4 0 0 1-.486.014"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M84.984 73.999V110"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "scale-backend_svg__path-6-inside-1_12030_11727",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.212 92H66h36.387-1.175Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.212 92H66h36.387-1.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.212 91.2H67.176v1.6h34.036zm-34.036 0h-.832v1.6h.832zm-.832 0zH66v1.6h.344zM66 92v.8h.344v-1.6H66zm.344.8h.832v-1.6h-.832zm.832 0h34.036v-1.6H67.176zm34.036 0zh.83v-1.6h-.831zm.831 0zh.343v-1.6h-.344zm.344-.8v-.8h-.344v1.6h.344zm-.344-.8h-.831v1.6h.831z",
    mask: "url(#scale-backend_svg__path-6-inside-1_12030_11727)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "scale-backend_svg__path-8-inside-2_12030_11727",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 51,
    x: 8,
    y: 40.499,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 51,
    x: 8,
    y: 40.499,
    fill: "#F0F1F1",
    stroke: "#2C3144",
    strokeWidth: 3,
    className: "scale-backend_svg__orange-rect",
    mask: "url(#scale-backend_svg__path-8-inside-2_12030_11727)",
    rx: 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "scale-backend_svg__path-9-inside-3_12030_11727",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 15,
    x: 8,
    y: 40.499,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 15,
    x: 8,
    y: 40.499,
    fill: "url(#scale-backend_svg__paint1_linear_12030_11727)",
    stroke: "#2C3144",
    strokeWidth: 3,
    className: "scale-backend_svg__white-border",
    mask: "url(#scale-backend_svg__path-9-inside-3_12030_11727)",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M37.32 78.419h-3.458a.707.707 0 0 1-.698-.702V63.308a.713.713 0 0 1 .698-.701h3.458a.697.697 0 0 1 .698.701v14.41a.703.703 0 0 1-.698.7m-2.76-1.403h2.062V64.01H34.56zM49.114 78.418h-3.447a.696.696 0 0 1-.698-.701v-4.789a.7.7 0 0 1 .698-.7h3.447a.696.696 0 0 1 .698.7v4.789a.703.703 0 0 1-.698.7m-2.75-1.402h2.052v-3.387h-2.051zM55.028 78.42h-3.447a.697.697 0 0 1-.698-.702V66.825a.703.703 0 0 1 .698-.701h3.447a.697.697 0 0 1 .698.7v10.894a.703.703 0 0 1-.698.701m-2.75-1.403h2.063v-9.491h-2.062z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 14,
    x: 27,
    y: 64.499,
    fill: "url(#scale-backend_svg__paint2_linear_12030_11727)",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 12,
    x: 39,
    y: 66.499,
    fill: "url(#scale-backend_svg__paint3_linear_12030_11727)",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M60.083 81.471H22.722a.696.696 0 0 1-.699-.701.703.703 0 0 1 .698-.701h37.362a.697.697 0 0 1 .698.7.7.7 0 0 1-.698.702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.31 50.203a2.55 2.55 0 0 1-1.416-.438 2.565 2.565 0 0 1-1.078-2.637c.1-.497.344-.953.702-1.311a2.55 2.55 0 0 1 2.784-.552 2.575 2.575 0 0 1 1.575 2.37 2.58 2.58 0 0 1-.755 1.817 2.56 2.56 0 0 1-1.811.75m0-3.732a1.16 1.16 0 0 0-1.063.727 1.17 1.17 0 0 0 .258 1.265 1.159 1.159 0 0 0 1.976-.827 1.17 1.17 0 0 0-.723-1.08 1.2 1.2 0 0 0-.447-.085M23.384 50.203a2.564 2.564 0 0 1-2.361-1.585 2.58 2.58 0 0 1 .554-2.797 2.55 2.55 0 0 1 2.785-.557 2.575 2.575 0 0 1 1.578 2.372 2.58 2.58 0 0 1-.752 1.812 2.56 2.56 0 0 1-1.804.755m0-3.732a1.16 1.16 0 0 0-1.072.719 1.17 1.17 0 0 0 .252 1.27 1.158 1.158 0 0 0 1.98-.824c0-.31-.122-.605-.34-.824a1.16 1.16 0 0 0-.82-.341M74.152 48.338H37.8a.696.696 0 0 1-.698-.7.7.7 0 0 1 .698-.702h36.352a.696.696 0 0 1 .698.701.7.7 0 0 1-.431.648.7.7 0 0 1-.267.053"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-backend_svg__paint0_linear_12030_11727",
    x1: 84.481,
    x2: 84.481,
    y1: 74.096,
    y2: 109.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-backend_svg__paint1_linear_12030_11727",
    x1: 41.5,
    x2: 41.5,
    y1: 40.499,
    y2: 55.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "scale-backend_svg__orange-gradient",
    stopColor: "#2C3144",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    className: "scale-backend_svg__orange-gradient",
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-backend_svg__paint2_linear_12030_11727",
    x1: 29.5,
    x2: 29.5,
    y1: 64.499,
    y2: 78.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-backend_svg__paint3_linear_12030_11727",
    x1: 41.5,
    x2: 41.5,
    y1: 66.499,
    y2: 78.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "scale-backend_svg__clip0_12030_11727"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h110v110H0z"
  })))));
};
export default SvgScaleBackend;